export default __webpack_public_path__ + "static/media/down.43a1c3cc.svg";